/**
 * Forma de cada pieza en el mosaico editorial (inspirado en los módulos de brands.mx).
 * Las celdas se definen en CSS por forma y breakpoint (`.mz-*`); aquí solo se decide la forma.
 * Las piezas nunca se recortan: siempre se ven completas (object-fit: contain). Por eso la forma
 * se elige por proporción, para que la celda se parezca a la pieza y el margen sea mínimo.
 *
 *  forma   escritorio (4 col)  proporción de la celda   piezas
 *  sq      1×1                 1.18                     cuadradas y horizontales suaves
 *  feat    2×2                 1.18                     pieza destacada
 *  tall    1×2                 0.59                     verticales (story, reel 9:16)
 *  cine    3×2                 1.76                     horizontales (16:9)
 *  banner  2×1                 2.35                     muy anchas (bloques, 728×90, 320×50)
 *  sky     1×2                 0.59                     rascacielos (160×600)
 *
 * fit: "full" ocupa toda la celda; "inset" deja aire alrededor para piezas pequeñas o extremas.
 */
export type TileShape = 'sq' | 'feat' | 'tall' | 'cine' | 'banner' | 'sky';

export interface TileInput {
  width: number | null;
  height: number | null;
  kind: string;
}

export interface Tile {
  shape: TileShape;
  fit: 'full' | 'inset';
  /** Miniatura grande para módulos que ocupan dos o más columnas. */
  variant: 'thumb' | 'large';
}

const WIDE: TileShape[] = ['feat', 'cine', 'banner'];

export function tileFor(piece: TileInput, indexInSection: number, squaresSoFar: number): Tile {
  const r = piece.width && piece.height ? piece.width / piece.height : 1;
  let shape: TileShape;
  if (r >= 2.05) shape = 'banner';
  else if (r <= 0.4) shape = 'sky';
  else if (r < 0.8) shape = 'tall';
  else if (r >= 1.45) shape = 'cine';
  // Piezas cuadradas u horizontales suaves: la primera de la sección y una de cada seis van destacadas.
  else shape = indexInSection === 0 || squaresSoFar % 6 === 5 ? 'feat' : 'sq';
  return {
    shape,
    fit: r >= 3 || shape === 'sky' ? 'inset' : 'full',
    variant: WIDE.includes(shape) ? 'large' : 'thumb',
  };
}

/** Formas para toda una sección, en orden. */
export function layoutSection(pieces: TileInput[]): Tile[] {
  let squares = 0;
  return pieces.map((p, i) => {
    const tile = tileFor(p, i, squares);
    if (tile.shape === 'sq' || tile.shape === 'feat') squares++;
    return tile;
  });
}
